import Vue from 'vue';
import global_mixin from './global_mixins.js'
import '../css/search.css'
var _ = require('lodash')
var URLSearchParams = require('url-search-params')
let urlParams = new URLSearchParams(window.location.search)
import { searchTiles, searchSeries, searchPages } from '../graphql/queries'


const app = new Vue({
  el: '#app',
  data() {
    return {
      searchQuery: '',
      searchResults: [],
      searched: false
    }
  },
  apollo: {
    getTiles: {
      query: searchTiles,
      update: data => data.searchTiles,
      debounce: 750,
      variables() {
        return {
          search: {
            "query": this.searchQuery,
          }
        }
      },
      skip() {
        return !this.cacheLoaded

      },
      watchLoading(isLoading) {
        this.isLoading = isLoading
      },
    },
    getSeries: {
      query: searchSeries,
      update: data => data.searchSeries,
      variables() {
        return {
          search: {
            "query": this.searchQuery,
          },
          filter: {
            "active": {"value": true}
          }
        }
      },
      skip() {
        return !this.cacheLoaded
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading
      },
    },
    getPages: {
      query: searchPages,
      update: data => data.searchPages,
      variables() {
        return {
          search: {
            "query": this.searchQuery,
          }
        }
      },
      skip() {
        return !this.cacheLoaded
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading
      },
    }
  },
  created() {
    if (urlParams.has('q')) {
      this.searchQuery = urlParams.get('q')
    }
  },
  computed: {
    searchItems() {
      let data = []

      if (this.getTiles) {
        for (let element of this.getTiles.edges) {
          data.push({
            'title': element.node.seriesName,
            'description': element.node.series.tagline,
            'url': element.node.seriesUrl
          })
        }
      }

      if (this.getSeries) {
        for (let element of this.getSeries.edges) {
          data.push({
            'title': element.node.name,
            'description': element.node.category && element.node.category.length ? element.node.tagline + `<br /> ${element.node.category}` : element.node.tagline,
            'url': element.node.url
          })
        }
      }

      if (this.getPages) {
        for (let element of this.getPages.edges) {
          data.push({
            'title': element.node.title,
            'description': element.node.description,
            'url': element.node.url
          })
        }
      }
      //let newData = [...new Set(data)]
      return _.uniqBy(data, 'url')
    }
  },
  methods: {
    
  },
  mixins: [global_mixin],
  watch: {
  }
})


// WEBPACK FOOTER //
// ./core/vue/js/search.js